"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DamShape = exports.TankShape = void 0;
var TankShape;
(function (TankShape) {
    TankShape["CYLINDER"] = "CYLINDER";
    TankShape["RECTANGLE"] = "RECTANGLE";
})(TankShape || (exports.TankShape = TankShape = {}));
var DamShape;
(function (DamShape) {
    DamShape["CYLINDER"] = "Rectangular";
    DamShape["CIRCULAR"] = "Circular";
    DamShape["GULLY"] = "Gully";
})(DamShape || (exports.DamShape = DamShape = {}));
